import React from "react";

import { Pencil, Trash2 } from "lucide-react";

import DataTableColumnHeader from "../../../components/dataTable/DataTableColumnHeader";
import {
  actionsColumn,
  dateColumn,
  dragHandleColumn,
} from "../../../components/dataTable/dataTableColumns";
import { LINK_CELL_CLASS } from "../../../components/dataTable/DataTableLinkCell";
import { cn } from "../../../lib/utils";

import type { TFunction } from "i18next";

import type { NotificationRow } from "../../../api/NotificationAPI.types";
import type { DataTableColumnDef } from "../../../components/dataTable/dataTable.types";

interface NotificationColumnsOptions {
  t: TFunction;
  onEdit: (notification: NotificationRow) => void;
  onDelete: (notification: NotificationRow) => void;
}

export function notificationColumns({
  t,
  onEdit,
  onDelete,
}: NotificationColumnsOptions): DataTableColumnDef<NotificationRow>[] {
  return [
    dragHandleColumn<NotificationRow>((notification) => notification.label),
    {
      id: "label",
      accessorKey: "label",
      enableSorting: false,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("tag_title")} />
      ),
      meta: { label: t("tag_title") },
      cell: ({ row }) => (
        <button
          onClick={() => onEdit(row.original)}
          type="button"
          className={cn(
            LINK_CELL_CLASS,
            "cursor-pointer text-left hover:underline",
          )}
        >
          {row.original.label}
        </button>
      ),
    },
    {
      ...dateColumn<NotificationRow>(
        "updated_at",
        t("editor-content:update_date"),
      ),
      enableSorting: false,
    },
    actionsColumn<NotificationRow>(
      (notification) => [
        {
          label: t("edit"),
          icon: <Pencil />,
          onClick: () => onEdit(notification),
        },
        {
          label: t("delete"),
          icon: <Trash2 />,
          variant: "destructive",
          onClick: () => onDelete(notification),
          confirm: {
            title: t("deleteTitle"),
            description: t("deleteBody", { tag: notification.label }),
            confirmLabel: t("confirm"),
          },
        },
      ],
      (notification) => notification.label,
    ),
  ];
}
